// extracted by mini-css-extract-plugin
export default {"mainContainer":"AppContainer_mainContainer__-DfIU","main":"AppContainer_main__BZCmq","footer":"AppContainer_footer__4babB"};